// extracted by mini-css-extract-plugin
export default {"cls1":"bcIEdwkiiSEKQPYwWSYO","cls2":"QXONxTsrZbyYFRpWpzQc bcIEdwkiiSEKQPYwWSYO"};